import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCopy, FiQrCode, FiX, FiCheck } = FiIcons;

const SessionInfo = ({ session, foundWords, isHost }) => {
  const [showQR, setShowQR] = useState(false);
  const [copied, setCopied] = useState(false);

  const sessionUrl = `${window.location.origin}/#/session/${session.id}`;

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(sessionUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6 mb-8 border border-gray-200">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-[#2b6777] mb-2 font-rubik">
            Buchstabensalat-Spiel
          </h1>
          <p className="text-[#2b6777] opacity-80 font-rubik">
            {foundWords.length} von {session.words.length} Wörtern gefunden
          </p>
        </div>
        
        {isHost && (
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={copyToClipboard}
              className="flex items-center gap-2 bg-[#c8d8e4] hover:bg-[#b5c7d1] text-white px-4 py-2 rounded-md transition-colors font-rubik"
            >
              <SafeIcon icon={copied ? FiCheck : FiCopy} />
              {copied ? 'Kopiert!' : 'Link kopieren'}
            </button>
            <button
              onClick={() => setShowQR(true)}
              className="flex items-center gap-2 bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-md transition-colors font-rubik"
            >
              <SafeIcon icon={FiQrCode} />
              QR-Code
            </button>
          </div>
        )}
      </div>

      {showQR && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setShowQR(false)}
        >
          <motion.div
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            className="bg-white rounded-lg p-6 max-w-sm w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold text-[#2b6777] font-rubik">QR-Code scannen</h3>
              <button
                onClick={() => setShowQR(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <SafeIcon icon={FiX} />
              </button>
            </div>
            <div className="flex justify-center mb-4">
              <QRCodeSVG value={sessionUrl} size={200} />
            </div>
            <p className="text-sm text-[#2b6777] text-center font-rubik opacity-80">
              Andere können diesen QR-Code scannen, um dem Spiel beizutreten.
            </p>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

export default SessionInfo;